import React from 'react';

import { isCommunity } from './utils/utils';

const MarketingIframe = () => (
	<iframe
		src={`https://www.totango.com/signup-${isCommunity ? 'community-1' : 'free-trial'}`}
		sandbox="allow-popups allow-popups-to-escape-sandbox"
		tabIndex={-1}
		title="marketing-iframe"
		frameBorder="0"
		height="100%"
		width="100%"
		style={{
			overflow: 'hidden',
			overflowX: 'hidden',
			overflowY: 'hidden',
		}}
	/>
);

export default MarketingIframe;
